import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, MenuItem, TextField, } from "@material-ui/core";
import { getUserTriggers } from "../../../store/constructs/user_triggers/selectors";
import { basic, validationMessages, requiredOnly } from '../../../config/validations';
import { userTriggerEventsList, userTriggerEventsListForControllerDelegate } from "../../../services/entities/user_triggers";
import { constructIds } from '../../../config/common';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { invokePostService, invokeGetService } from "../../../store/global/actions";
import { mainTransInAlphabeticalOrder } from "../../../services/entities/user_triggers";
import { handleSnackBar } from '../../../store/global/actions';
import { validateNonAsciiChars } from "../../../utils/commonUtils";
import ExtendUTFields from "./ExtendUTFields";
const shortUUid = require("short-uuid");

export default function CreateUserTrigger({ onCompletion, onClose, element, tag }) {
    const dispatch = useDispatch();
    // const transactions = useSelector(getTransInAlphabeticalOrder);
    const [transactions, setTransactions] = useState([])
    // const allEvents = useSelector(getEvents);
    const [allEvents, setAllEVents] = useState([])
    const allUserTriggers = useSelector(getUserTriggers)
    // const mainTransactionsOnly = useSelector(getMainTransInAlphabeticalOrder)
    const [mainTransactionsOnly, setMainTransaction] = useState([])
    // const allTransactions = useSelector(getAllTransactions);
    const [allTransactions, setAllTrans] = useState([])

    // const clusterlets = useSelector(getClusterlets);
    const [clusterlets, setClusterlets] = useState([])
    const [events, setEvents] = useState([]);
    const [isCreating, setIsCreating] = useState(false)
    const [utExtensionFileds, setUTExtensionFileds] = useState(null);
    

    const [defaultObj, setDefaultObj] = useState({ tag: null, transaction: "", event: "", type: "", name: "", desc: "" })
    const { register, handleSubmit, formState: { errors }, control, getValues, setValue } = useForm();
    const controllerDelegate = element?.subType && element.subType === 'controller' ? true : false

    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((response) => {
                if (response.data !== undefined) {
                    setClusterlets(response.data.clusterlets)
                    setAllEVents(response.data.events)
                    setTransactions(mainTransInAlphabeticalOrder(response.data.transactions));
                    setMainTransaction(mainTransInAlphabeticalOrder(response.data.transactions))
                    setAllTrans(response.data.transactions)

                    console.log('user trigger', {etype: element.type}, constructIds,constructIds.find(item => item.type === "events").id)
                    if (element.type === constructIds.find(item => item.type === "events").id) {
                        const tag = "event";
                        const event = element.id;
                        const name = element.name;
                        const desc = element.desc;
                        const transaction = response.data.transactions?.find(item => {
                            const transEvents = item.events.map(event => event.id)
                            if (transEvents.includes(element.id)) return item;
                        })?._id;
                        const type = response.data.clusterlets.find(clusterlet => clusterlet._id == element.item.dst)?.name;


                        setValue('transaction', transaction);
                        setValue('event', event);
                        setValue('name', name);
                        setValue('type', type);
                        setValue('description', desc)

                        setDefaultObj({ tag, event, name, transaction, type, desc });
                        setEvents([{ label: element.name, value: element.id }])
                    }
                }
            })
    }, [])

    // useEffect(() => {
    //     if (element.type === constructIds.find(item => item.type === "events").id) {
    //         const tag = "event";
    //         const event = element.id;
    //         const name = element.name;
    //         const desc = element.desc;
    //         const transaction = allTransactions?.find(item => {
    //             const transEvents = item.events.map(event => event.id)
    //             if (transEvents.includes(element.id)) return item;
    //         })?.id;
    //         const type = clusterlets.find(clusterlet => clusterlet.id === element.dst).name;

    //         setValue('transaction', transaction);
    //         setValue('event', event);
    //         setValue('name', name);
    //         setValue('type', type);
    //         setValue('description', desc)

    //         setDefaultObj({ tag, event, name, transaction, type, desc });
    //         setEvents([{ label: element.name, value: element.id }])
    //     }
    // }, [])

    const messages = {
        ...validationMessages,
        maxLength: 'Description cannot exceed 200 characters'
    }

    const populateEvents = () => {
        const { transaction } = getValues();
        let userTriggerEvents = controllerDelegate === false ?
            userTriggerEventsList({ transaction, delegate: element.id, allEvents, allTransactions, allUserTriggers })
            : userTriggerEventsListForControllerDelegate({ transaction, allEvents, allTransactions, allUserTriggers, allClusterlets: clusterlets })

        setEvents(userTriggerEvents)
    }

    const listenChange = () => {
        const { transaction } = getValues();

        if (transaction === undefined || transaction === "") {
            setEvents([])
            setValue("description", "")
            setValue("event", "")
            return
        }
        populateEvents()
    }

    const listenEvent = () => {

        const { event } = getValues();

        if (event === undefined || event === '') {
            setValue("description", "")
        }

        if (event !== undefined && event != '') {
            const eventData = allEvents.find(item => item._id == event)
            const clusterlet = clusterlets.find(clusterlet => clusterlet._id == eventData.dst);
            setValue("name", eventData.name)
            setValue("type", clusterlet.name)
            setValue("description", eventData.desc)
        }
    }

    const onSave = async (data) => {
        setIsCreating(true);

        const { transaction, event, /*name,*/ description, /*instance,*/ instanceDesc } = data;

        const selectedEvent = allEvents.find(item => item._id == event)
        const userTriggerType = clusterlets.find(item => item._id == selectedEvent.dst);
        const newUserTriggerId = shortUUid.generate();
        const newFieldId = shortUUid.generate();
        const instanceName = userTriggerType.name.toLowerCase();



        let newUserTrigger = {
            type: constructIds.find(x => x.type === 'user_trigger').id,
            name: selectedEvent.name,
            attributes: {
                cmdtype: "cmd",
                desc: description,
                type: userTriggerType._id,
                op: selectedEvent._id
            },
            extensions: []
        }

        let newField = {
            id: newFieldId,
            type: constructIds.find(x => x.type === 'field').id,
            // name: instance,
            name: `${instanceName}_Name`,
            attributes: {
                // desc: instanceDesc,
                type: "OCTETSTRING",
                target: "url"
            },
        }


        dispatch(invokePostService('createUserTrigger', { userTriggerData: newUserTrigger, fieldData: newField }, []))
            .then(savedData => {
                setIsCreating(false);
                if (savedData.status) {
                    onCompletion('User trigger', 'add', undefined, undefined, savedData?.data?.userTrigger);
                }
                else {
                    dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));

                }


            })
            .catch(error => console.error(error));
    }

    return (
        <Grid id={"create_usertrigger_form"} container direction={"row"} spacing={3}>
            <Grid item xs={6}>
                <Controller
                    name="transaction"
                    control={control}
                    defaultValue={defaultObj.transaction}
                    rules={{ required: true, requiredOnly }}
                    render={({ field, value, onChange }) =>
                        <TextField
                            {...field}
                            autoFocus
                            label={'Transaction Name'}
                            disabled={defaultObj.tag === "event" ? true : false}
                            select
                            value={value}
                            fullWidth
                            required
                            variant={'outlined'}
                            onChange={e => { onChange(e); listenChange(e) }}
                            error={errors?.transaction ? true : false}
                            helperText={messages[errors?.transaction?.type] || ''}
                        >
                            <MenuItem key={123} value={""}>Select a transaction</MenuItem>
                            {mainTransactionsOnly.map((option) => (
                                <MenuItem key={option.value} value={option.value} >
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    }
                />
            </Grid>

            <Grid item xs={6}>
                <Controller
                    name="event"
                    control={control}
                    defaultValue={defaultObj.event}
                    rules={{ required: true, requiredOnly }}
                    render={({ field, value, onChange }) =>
                        <TextField
                            {...field}
                            name="event"
                            label={"Event Name"}
                            disabled={defaultObj.tag === "event" ? true : false}
                            fullWidth
                            required
                            select
                            value={value}
                            variant="outlined"
                            onChange={e => { onChange(e); listenEvent(e) }}
                            error={errors?.event ? true : false}
                            helperText={messages[errors?.event?.type] || ''}
                        >
                            <MenuItem key={123} value={""}>Select event</MenuItem>
                            {events.map((option) => (
                                <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    }
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    name="description"
                    label={"Description"}
                    required
                    fullWidth
                    // multiline
                    defaultValue={defaultObj.desc}
                    // rows={2}
                    // maxRows={2}
                    variant="outlined"
                    type={"text"}
                    inputRef={register({ required: true, maxLength: 150, validate: validateNonAsciiChars })}
                    error={errors?.description ? true : false}
                    helperText={errors?.description?.message || messages[errors?.description?.type] || ''}
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    name="type"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    label={"Target"}
                    type={"text"}
                    fullWidth
                    defaultValue={defaultObj.type}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    disabled
                />
            </Grid>

            {/* <Grid item xs={12}>
                {tag == "event" && <ExtendUTFields eventId={element.id} onClose={onClose} onCompletion={onCompletion} setUTExtensionFileds={setUTExtensionFileds}/>}
            </Grid> */}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <CreateCancel forceCancel onCreate={handleSubmit(onSave)} cancelText='Back' onCancel={onClose} createDisable={isCreating} content={isCreating ? 'Creating..' : 'Create'} hideCancel={tag=="event" ? true :false}/>
            </Grid>

        </Grid>
    );
}
